<template>
  <div id="home">
    <v-app-bar
      class="bar-color"
      elevation="0"
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-spacer class="hidden-menu"></v-spacer>
      <v-img
        class="mr-5 ml-5"
        max-width="150"
        :src="require('@/assets/images/landingpage/logoLogin.png')"
      ></v-img>
      <v-spacer></v-spacer>
      <template>
        <div class="hidden-menu">
          <v-btn
            rounded
            text
            class="menu-text"
            :href="menu.link"
            v-for="(menu, i) in items"
            :key="i"
          >
            {{ menu.text }}
          </v-btn>
        </div>
        <v-spacer class="hidden-menu"></v-spacer>
        <div class="hidden-menu">
          <v-btn
            rounded
            text
            class="menu-text"
            @click="$router.push({ name: 'loginPage' }).catch(() => {})"
          >
            Login
          </v-btn>
        </div>
      </template>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon
        color="textLandingPage"
        class="mr-4 hidden-navigation-drawers"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      temporary
      app
    >
      <v-list nav>
        <v-list-item-group v-model="group" active-class="primary--text">
          <v-list-item v-for="(menu, i) in items" :key="i" :href="menu.link">
            <v-list-item-title class="menu-text">{{
              menu.text
            }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            to="loginPage"
            @click="$router.push({ name: 'loginPage' }).catch(() => {})"
          >
            <v-list-item-title class="menu-text">Login</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <div class="d-flex justify-center mt-10" style="position: relative">
      <div class="d-flex flex-wrap mt-md-16 mt-10 mx-5 width-content-all">
        <div class="d-flex align-center width-content">
          <div class="pr-md-8">
            <div class="title-text">AI - CXR Screening</div>
            <div class="subTitle-text">
              ระบบคัดกรองผู้ป่วยจากภาพถ่ายรังสีทรวงอก
            </div>
            <div class="details-text mt-5">
              ระบบที่ช่วยแพทย์ในการคัดกรองความเสี่ยงการเกิดโรคต่างๆ เช่น วัณโรค
              โดยนำเข้าข้อมูลภาพถ่ายรังสีทรวงอก จากนั้นระบบ AI
              จะทำการวิเคราะห์ภาพและลักษณะทางกายภาพของการเกิดโรคต่างๆ
              เพื่อใช้เป็นเครื่องมือช่วยสำหรับแพทย์ในการคัดกรองผู้ป่วยเบื้องต้นก่อนยืนยันการอ่านผลจากแพทย์อีกครั้ง
            </div>
          </div>
        </div>
        <div
          class="position-content width-content d-flex justify-center mt-10 mt-md-0"
        >
          <v-img
            contain
            style="width: 100%; max-width: 450px"
            :src="require('@/assets/images/landingpage/Cxr.jpg')"
          ></v-img>
          <v-img
            contain
            class="img-absolute-section1"
            :src="require('@/assets/images/landingpage/Cxr2.png')"
          ></v-img>
        </div>
      </div>
    </div>

    <div id="aboutUs" class="d-flex justify-center mt-10">
      <div class="d-flex flex-wrap mt-md-16 mt-10 mx-5 width-content-all mb-0">
        <div
          class="position-content width-content d-flex justify-center mt-10 mt-md-0 pr-md-8 order-2 order-md-1"
        >
          <v-img
            contain
            style="width: 100%; max-width: 500px"
            :src="require('@/assets/images/landingpage/Benefits.jpg')"
          ></v-img>
          <v-img
            contain
            class="img-absolute-section2"
            :src="require('@/assets/images/landingpage/Benefits2.png')"
          ></v-img>
        </div>
        <div
          class="position-content d-flex align-center width-content order-1 order-md-2"
        >
          <div>
            <div class="title-text">Benefits to customer</div>
            <div class="details-text mt-5">
              <div>&bull; ช่วยให้โรงพยาบาลคัดกรองผู้ป่วยได้รวดเร็วยิ่งขึ้น</div>
              <div>
                &bull;
                ช่วยชี้จุดลักษณะทางกายภาพของโรคให้กับทางแพทย์ได้เด่นชัดขึ้น
              </div>
              <div>&bull; ผู้ป่วยได้รับการตรวจรักษาทันท่วงที</div>
              <div>&bull; ลดอัตราการเสียชีวิตของผู้ป่วย</div>
              <div>&bull; ช่วยลดต้นทุนในการส่งเสมหะของผู้ป่วยไปตรวจสอบ</div>
            </div>
          </div>
          <div class="bg-absolute-right"></div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-center mt-10" style="position: relative">
      <div class="d-flex flex-wrap mt-md-16 mt-10 mx-5 width-content-all">
        <div class="position-content d-flex align-center width-content">
          <div class="pr-md-8">
            <div class="title-text">โรคที่ระบบรองรับการ Screening</div>
            <div class="details-text mt-5">
              <div class="subTitle-text">Pathology</div>
              <div>&bull; Tuberculosis วัณโรค</div>
              <div>&bull; Pneumothorax ภาวะปอดรั่ว</div>
              <div>&bull; Emphysema ถุงลมโป่งพอง</div>
              <div>&bull; Pneumonia ปอดบวม</div>
            </div>
          </div>
          <div class="bg-absolute-left"></div>
        </div>
        <div
          class="position-content width-content d-flex justify-center mt-10 mt-md-0"
        >
          <v-img
            contain
            style="width: 100%; max-width: 420px"
            :src="require('@/assets/images/landingpage/Screening.jpg')"
          >
          </v-img>
          <v-img
            contain
            class="img-absolute-section3"
            :src="require('@/assets/images/landingpage/Screening2.png')"
          ></v-img>
        </div>
      </div>
    </div>

    <div id="services" class="d-flex justify-center">
      <div class="mt-md-16 mt-10 mx-5 width-content-all">
        <div class="title-text">SERVICES</div>
        <div class="details-text mt-5">
          มีบริการต่าง ๆ ในระบบให้เลือกใช้ อาทิเช่น
        </div>
      </div>
    </div>

    <div class="d-flex justify-center">
      <div
        class="mt-md-10 mt-10 mx-3 width-content-all d-flex flex-wrap justify-space-between"
      >
        <div v-for="(service, i) in service" :key="i" class="pa-5 card-service">
          <div class="d-flex justify-center">
            <div class="d-flex justify-center icon-services">
              <v-icon color="iconLandingPage" size="50">
                {{ service.icon }}
              </v-icon>
            </div>
          </div>

          <div class="my-5 services-title text-center">{{ service.title }}</div>
          <div class="mt-5 services-content text-center">
            {{ service.detail }}
          </div>
        </div>
      </div>
    </div>

    <div id="contactUs" class="d-flex justify-center mb-5">
      <div
        class="mt-md-10 mt- mx-5 width-content-all d-flex flex-wrap justify-space-between"
      >
        <diV class="contact-width-content mt-10">
          <div class="title-text d-flex justify-center">CONTACT US</div>
          <div class="details-text mt-2 d-flex justify-center">
            ติดต่อเราได้ผ่านช้องทางนี้
          </div>
          <v-form ref="formContact" v-model="validContactForm">
            <div class="d-flex flex-wrap pt-10">
              <div class="width-text-field">
                <v-text-field
                  v-model="fromContact.first_name"
                  :rules="[Rule.noInPut, Rule.noSpace]"
                  :disabled="loading"
                  label="ชื่อ"
                  placeholder="กรอกชื่อ"
                  outlined
                  rounded
                  dense
                  class="mb-n2"
                ></v-text-field>
              </div>
              <v-spacer></v-spacer>
              <div class="width-text-field">
                <v-text-field
                  v-model="fromContact.last_name"
                  :rules="[Rule.noInPut, Rule.noSpace]"
                  :disabled="loading"
                  label="นามสกุล"
                  placeholder="กรอกนามสกุล"
                  outlined
                  rounded
                  dense
                  class="mb-n2"
                ></v-text-field>
              </div>
            </div>

            <div class="d-flex flex-wrap">
              <div class="width-text-field">
                <v-text-field
                  v-model="fromContact.email"
                  :rules="[Rule.noInPut, Rule.englishOnly, Rule.emailOnly]"
                  :disabled="loading"
                  label="อีเมล"
                  placeholder="กรอกอีเมล"
                  outlined
                  rounded
                  dense
                  class="mb-n2"
                ></v-text-field>
              </div>
              <v-spacer></v-spacer>
              <div class="width-text-field">
                <v-text-field
                  v-model="fromContact.phone"
                  required
                  :rules="[Rule.noInPut, Rule.numberOnly, Rule.phoneNumber]"
                  :disabled="loading"
                  label="เบอร์โทร"
                  placeholder="กรอกเบอร์โทร"
                  outlined
                  rounded
                  dense
                  class="mb-n2"
                ></v-text-field>
              </div>
            </div>

            <div>
              <v-text-field
                v-model="fromContact.subject"
                :rules="[Rule.noInPut]"
                :disabled="loading"
                label="หัวข้อ"
                placeholder="กรอกหัวข้อ"
                outlined
                rounded
                dense
                class="mb-n2"
              ></v-text-field>
            </div>
            <div>
              <v-textarea
                v-model="fromContact.description"
                :rules="[Rule.noInPut]"
                :disabled="loading"
                outlined
                label="รายละเอียด"
                placeholder="กรอกรายละเอียด"
                rounded
                class="mb-n2"
              ></v-textarea>
            </div>
          </v-form>
          <diV>
            <v-btn
              @click="SendContact"
              :disabled="!validContactForm"
              :loading="loading"
              block
              rounded
              elevation="0"
              class="btn-contact"
            >
              ส่งข้อความ
            </v-btn>
          </diV>
        </diV>
        <diV class="contact-width-content flex-wrap pa-10 mt-10">
          <div>
            <div class="position-content d-flex justify-center">
              <v-img
                class="mb-7"
                max-width="300"
                :src="require('@/assets/images/landingpage/contact.jpg')"
              ></v-img>
              <v-img
                contain
                class="img-absolute-section-mail"
                :src="require('@/assets/images/landingpage/contact2.png')"
              ></v-img>
            </div>

            <div class="contact-contact">
              <span>
                <v-icon color="textLandingPage" size="30">
                  mdi-email
                </v-icon> </span
              ><a class="text-contact" href="mailto:contact@manageai.co.th">
                : contact@manageai.co.th
              </a>
            </div>

            <div class="contact-contact">
              <span>
                <v-icon color="textLandingPage" size="30">
                  mdi-phone
                </v-icon> </span
              ><a class="text-contact" href="tel:+02 257 7197">
                : 02 257 7197
              </a>
            </div>

            <div class="contact-contact">
              <span>
                <v-icon color="textLandingPage" size="30">
                  mdi-map-marker
                </v-icon> </span
              ><a
                class="text-contact"
                href="https://goo.gl/maps/62cQSYKcgNhuy16L7"
                target="_blank"
              >
                : 1768 อาคารไทยซัมมิททาวเวอร์ ชั้น 16 ถ.เพชรบุรีตัดใหม่
                แขวงบางกะปิ เขตห้วยขวาง กทม 10310</a
              >
            </div>
          </div>
        </diV>
      </div>
    </div>
    <div class="footer py-2">©2022 — ManageAI Solution Co.,Ltd.</div>
  </div>
</template>

<script>
import AOS from 'aos'
import 'aos/dist/aos.css'
AOS.init()
export default {
  data () {
    return {
      loading: false,
      validContactForm: false,
      fromContact: {
        email: '',
        first_name: '',
        last_name: '',
        subject: '',
        phone: '',
        description: ''
      },
      drawer: false,
      group: null,
      items: [
        { text: 'Home', link: '#home' },
        { text: 'About Us', link: '#aboutUs' },
        { text: 'Services', link: '#services' },
        { text: 'Contact Us', link: '#contactUs' }
      ],
      service: [
        {
          icon: 'mdi-fit-to-screen',
          title: 'Screening',
          detail:
            'ทำการวิเคราะห์ภาพและลักษณะทางกายภาพของการเกิดโรคต่างๆ ด้วย AI'
        },
        {
          icon: 'mdi-clipboard-text-clock',
          title: 'History',
          detail: 'ดูประวัติการตรวจหาโรคที่เคยใช้งาน'
        },
        {
          icon: 'mdi-chart-pie',
          title: 'Dashboard',
          detail: 'แสดงภาพรวมการใช้งานระบบของหน่วยงาน'
        },
        {
          icon: 'mdi-account-group',
          title: 'Manage User',
          detail: 'จัดการบัญชีผู้ใช้งานในหน่วยงาน'
        }
      ]
    }
  },
  methods: {
    SendContact () {
      this.$swal({
        allowEnterKey: false,
        title: 'ติดต่อเรา',
        text: 'ข้อมูลทั้งหมดจะถูกส่งไปยังผู้ดูแลระบบ คุณต้องการส่งข้อมูลเพื่อติดต่อเราใช่หรือไม่',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ตกลง'
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loading = true
          const payload = this.fromContact
          const res = await this.sendContact(payload)
          this.loading = false
          if (res.status) {
            this.$swal({
              allowEnterKey: false,
              title: 'สำเร็จ',
              text: 'ส่งข้อมูลติดต่อสำเร็จ',
              icon: 'success',
              showConfirmButton: false,
              showCancelButton: false,
              timer: 3000
            })
            this.$refs.formContact.reset()
            this.$refs.formContact.resetValidation()
          } else {
            this.antmessage.error(res.message)
          }
        }
      })
    }
  }
}
</script>

<style>
.menu-text a {
  color: var(--v-textLandingPage-base);
  text-decoration: none;
}
.width-content {
  width: 50%;
}
.text-title {
  color: var(--v-textLandingPage-base);
  font-size: 22px;
  font-weight: 400;
}
.menu-text {
  color: var(--v-textLandingPage-base) !important;
  font-size: 18px !important;
  font-weight: 400;
  text-transform: capitalize;
}
.bar-color {
  background-color: var(--v-bgLandingPageMenu-base) !important;
}
.hidden-menu {
  display: flex;
}

.title-text {
  color: var(--v-textLandingPage-base) !important;
  font-size: 34px !important;
  font-weight: 500;
}
.subTitle-text {
  color: var(--v-textLandingPage-base) !important;
  font-size: 26px !important;
  font-weight: 400;
}
.details-text {
  color: var(--v-contentTextLandingPage-base) !important;
  font-size: 20px !important;
  font-weight: 300;
}
.width-content-all {
  width: 70% !important;
}
.services-title {
  color: var(--v-textLandingPage-base) !important;
  font-size: 22px !important;
  font-weight: 400;
}
.services-content {
  color: var(--v-contentTextLandingPage-base) !important;
  font-size: 18px !important;
  font-weight: 300;
}
.icon-services {
  background-color: var(--v-bgBtnLandingPage-base);
  border-radius: 86px;
  width: 85px;
  height: 85px;
}
.card-service {
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.13);
  width: 22%;
  border-radius: 3px;
}
.card-service:hover {
  box-shadow: 0px 0px 8px var(--v-shadow-base);
  transform: scale(1.1);
  transition-duration: 0.5s;
  border-radius: 3px;
}

.contact-width-content {
  width: 47%;
}
.btn-contact {
  color: var(--v-textLandingPage-base) !important;
  font-size: 16px !important;
  font-weight: 400;
  background-color: var(--v-bgBtnLandingPage-base) !important;
}
.contact-contact {
  color: var(--v-textLandingPage-base) !important;
  font-size: 18px !important;
  font-weight: 300;
  margin-bottom: 20px;
}
.footer {
  font-size: 16px;
  font-weight: 300;
  text-align: center;
  background-color: var(--v-footerLandingPage-base) !important;
  color: var(--v-textLandingPage-base) !important;
}
.img-absolute-section1 {
  z-index: 1;
  position: absolute;
  top: 30%;
  width: 50%;
  height: 40%;
  animation: zoom-in-zoom-out 2s ease infinite;
}
.text-contact {
  color: var(--v-textLandingPage-base) !important;
}
@keyframes zoom-in-zoom-out {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.5, 1.5);
  }
  100% {
    transform: scale(1, 1);
  }
}
.img-absolute-section2 {
  z-index: 1;
  position: absolute;
  top: 15%;
  right: 0%;
  width: 100%;
  height: 50%;
  animation: anination-section2 4s ease infinite;
}
@keyframes anination-section2 {
  0% {
    left: 0px;
    top: 0px;
  }
  25% {
    left: 100px;
    top: 0px;
  }
  50% {
    left: 100px;
    top: 100px;
  }
  75% {
    left: 0px;
    top: 100px;
  }
  100% {
    left: 0px;
    top: 0px;
  }
}
.img-absolute-section3 {
  z-index: 1;
  position: absolute;
  top: 20%;
  right: 40%;
  width: 200px;
  height: 50%;
  animation: zoom-in-zoom-out-section3 3s ease infinite;
}
@keyframes zoom-in-zoom-out-section3 {
  0% {
    transform: scale(1, 1);
    left: 0px;
    top: 80px;
  }
  50% {
    transform: scale(1.5, 1.5);
    left: 80px;
    top: 0px;
  }
  100% {
    transform: scale(1, 1);
    left: 0px;
    top: 80px;
  }
}
.img-absolute-section-mail {
  z-index: 1;
  position: absolute;
  top: 35%;
  right: 18%;
  width: 80px;
  height: 50%;
  animation: zoom-in-zoom-out 2s 1s ease infinite;
}
.bg-absolute-right {
  z-index: -1;
  position: absolute;
  top: 10%;
  left: 23%;
  width: 120%;
  height: 80%;
  border-radius: 181px 0px 0px 181px;
  background-color: var(--v-bgLandingPageMenu-base) !important;
}
.bg-absolute-left {
  z-index: -1;
  position: absolute;
  top: 10%;
  right: 23%;
  width: 130%;
  height: 80%;
  border-radius: 0px 181px 181px 0px;
  background-color: var(--v-bgLandingPageMenu-base) !important;
}
.position-content {
  position: relative;
  z-index: 0;
}
@media screen and (min-width: 960px) {
  .hidden-navigation-drawers {
    display: none !important;
  }
}
@media screen and (max-width: 959px) {
  .bg-absolute-right {
    z-index: -1;
    position: absolute;
    top: 10%;
    left: 23%;
    width: 86%;
    height: 80%;
    border-radius: 181px 0px 0px 181px;
    background-color: var(--v-bgLandingPageMenu-base) !important;
  }
  .hidden-menu {
    display: none !important;
  }
  .width-content {
    width: 100% !important;
  }
  .width-content-all {
    width: 85% !important;
  }
  .card-service {
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.13);
    width: 100%;
    border-radius: 3px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
}

@media screen and (max-width: 700px) {
  .contact-width-content {
    width: 100%;
  }
}
.width-text-field {
  width: 48%;
}
@media screen and (max-width: 600px) {
  .width-text-field {
    width: 100%;
  }
}
</style>
